export { NewsPage } from "./ui/news-page";